import { motion } from "framer-motion";
import RainbowIcon from "../../../app/assets/images/storyMagic/rainbowIcon.png";
import SunIcon from "../../../app/assets/images/storyMagic/sun.png";

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const DreamSection = () => {
  return (
    <motion.div
      className="flex justify-center items-center flex-col py-6 sm:py-11 sm:pt-[60px] relative z-0 text-white text-center gap-2"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
      variants={staggerContainer}
    >
      <motion.h3
        className="flex items-center gap-3 text-3xl sm:text-[50px] font-bold uppercase"
        variants={fadeInUp}
      >
        <img src={RainbowIcon} className="w-8" alt="icon" />
        The Dream
      </motion.h3>
      <motion.h4
        className="text-2xl sm:text-3xl relative px-4"
        variants={fadeInUp}
      >
        To inspire a world where anyone can become a storyteller.
        <motion.img
          className="top-6 left-9 absolute max-w-[130px] -translate-y-[100%] -translate-x-full hidden sm:block"
          src={SunIcon}
          alt=""
          initial={{ opacity: 0, scale: 0, rotate: -180 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            rotate: 0,
          }}
          viewport={{ once: false }}
          animate={{
            rotate: [0, 360],
            scale: [1, 1.1, 1],
          }}
          transition={{
            opacity: { delay: 0.4, duration: 0.8, ease: "easeOut" },
            scale: {
              delay: 1.2,
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.5, 1],
            },
            rotate: {
              delay: 1.2,
              duration: 20,
              repeat: Infinity,
              ease: "linear",
            },
            default: { delay: 0.4, duration: 0.8, ease: "easeOut" },
          }}
        />
      </motion.h4>
      <motion.p
        className="text-[#D1D1D1] text-lg sm:text-xl items-center max-w-[1200px] px-4"
        variants={fadeInUp}
      >
        Story Magic envisions a creative future where children read tales
        featuring themselves, teachers bring lessons to life through stories,
        and creators share boundless imagination all with the help of AI. Our
        dream is to merge technology and creativity to spark imagination,
        learning, and joy in every story created.
      </motion.p>
    </motion.div>
  );
};

export default DreamSection;
